@for (country of countries(); track country.countryCode) {
  <div class="mb-8" *transloco="let t; prefix: 'wizard.company'">
    <p-panel [toggleable]="true" [style]="{'border': 'none'}">
      <ng-template #header>
        <div class="flex items-end gap-2">
          <span class="font-bold">{{
            countryService.getCountryNameByCode(country.countryCode)
          }}</span>
          <span class="text-sm text-muted-color">
            {{ cities()[country.countryCode].length || 0 }}
            {{
              (cities()[country.countryCode].length || 0) === 1
                ? (t('city') | lowercase)
                : t('cities')
            }}
          </span>
        </div>
      </ng-template>
      <div class="p-2">
        @for (city of cities()[country.countryCode]; track $index) {
          <div class="flex flex-col gap-2 pt-6">
            <label for="city-{{ country.countryCode }}-{{ $index }}">
              {{ t('cityLabel', {number: $index + 1}) }}
            </label>
            <div class="flex items-center gap-5">
              <input
                #cityInput
                pInputText
                id="city-{{ country.countryCode }}-{{ $index }}"
                [attr.data-testid]="'city-' + country.countryCode + '-' + $index"
                type="text"
                placeholder="{{ t('enterCityNamePlaceholder') }}"
                class="w-full"
                [value]="city.name"
                [ngClass]="{'p-invalid': shouldShowCityError(country.countryCode, $index)}"
                (input)="onCityNameChange(country.countryCode, $index, cityInput.value)"
                (blur)="onCityBlur(country.countryCode, $index, cityInput.value)"
                required
              />
              @if ($count > 1) {
                <button
                  [attr.data-testid]="'delete-city-' + country.countryCode + '-' + $index"
                  type="button"
                  class="text-gray-400 hover:text-gray-300 transition-colors p-2 self-end"
                  (click)="removeCity(country.countryCode, $index)"
                  [disabled]="!isCityDeletable(country.countryCode, $index)"
                  [pTooltip]="
                    !isCityDeletable(country.countryCode, $index)
                      ? t('cityCannotBeDeleted')
                      : undefined
                  "
                >
                  <i class="pi pi-trash"></i>
                </button>
              }
            </div>
            @if (shouldShowCityError(country.countryCode, $index)) {
              @if (!city.name || city.name.trim().length === 0) {
                <p-message severity="error" variant="simple" size="small">
                  {{ t('cityNameRequired') }}
                </p-message>
              } @else if (isCityDuplicate(country.countryCode, $index, city.name)) {
                <p-message severity="error" variant="simple" size="small">
                  {{ t('cityNameAlreadyExists') }}
                </p-message>
              }
            }
          </div>
        }
        <button
          [attr.data-testid]="'add-city-' + country.countryCode"
          class="flex items-center gap-2 text-gray-400 hover:text-gray-300 transition-colors pt-6"
          (click)="addCity(country.countryCode)"
        >
          <i class="pi pi-plus-circle"></i>
          <span>{{ t('addCity') }}</span>
        </button>
      </div>
    </p-panel>
  </div>
}
